/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Primary_Group_HelpInputs */

const en_metadata_merge_primary_group_help = /** @type {(inputs: Metadata_Merge_Primary_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The primary group provides the events and timing for the merged result. Metadata from the other selected groups will be merged into it.`)
};

const fr_metadata_merge_primary_group_help = /** @type {(inputs: Metadata_Merge_Primary_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le groupe principal fournit les événements et le calendrier du résultat fusionné. Les métadonnées des autres groupes sélectionnés y seront intégrées.`)
};

const de_metadata_merge_primary_group_help = /** @type {(inputs: Metadata_Merge_Primary_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die primäre Gruppe liefert die Ereignisse und den Zeitpunkt für das zusammengeführte Ergebnis. Metadaten aus den anderen ausgewählten Gruppen werden in diese Gruppe integriert.`)
};

const it_metadata_merge_primary_group_help = /** @type {(inputs: Metadata_Merge_Primary_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo principale fornisce gli eventi e le tempistiche per il risultato aggregato. I metadati degli altri gruppi selezionati verranno integrati in esso.`)
};

const ru_metadata_merge_primary_group_help = /** @type {(inputs: Metadata_Merge_Primary_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основная группа предоставляет информацию о событиях и времени, которые будут учтены при формировании объединенного результата. Метаданные из других выбранных групп будут объединены с ней.`)
};

const es_metadata_merge_primary_group_help = /** @type {(inputs: Metadata_Merge_Primary_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El grupo principal proporciona los eventos y la sincronización para el resultado combinado. Los metadatos de los demás grupos seleccionados se fusionarán con él.`)
};

const zh_cn2_metadata_merge_primary_group_help = /** @type {(inputs: Metadata_Merge_Primary_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主组提供合并结果所需的事件和时间信息。其他选定组的元数据将合并到主组中。`)
};

const ja_metadata_merge_primary_group_help = /** @type {(inputs: Metadata_Merge_Primary_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライマリグループは、統合結果のイベントとタイミング情報を提供します。選択された他のグループからのメタデータは、プライマリグループに統合されます。`)
};

const hi_metadata_merge_primary_group_help = /** @type {(inputs: Metadata_Merge_Primary_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्राथमिक समूह संयुक्त परिणाम के लिए घटनाओं और समय की जानकारी प्रदान करता है। अन्य चयनित समूहों से मेटाडेटा इसमें विलय कर दिया जाएगा।`)
};

const pt_pt2_metadata_merge_primary_group_help = /** @type {(inputs: Metadata_Merge_Primary_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo principal fornece os eventos e o cronograma para o resultado consolidado. Os metadados dos outros grupos selecionados serão incorporados a ele.`)
};

/**
* | output |
* | --- |
* | "The primary group provides the events and timing for the merged result. Metadata from the other selected groups will be merged into it." |
*
* @param {Metadata_Merge_Primary_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_primary_group_help = /** @type {((inputs?: Metadata_Merge_Primary_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Primary_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_primary_group_help(inputs)
	if (locale === "de") return de_metadata_merge_primary_group_help(inputs)
	if (locale === "it") return it_metadata_merge_primary_group_help(inputs)
	if (locale === "ru") return ru_metadata_merge_primary_group_help(inputs)
	if (locale === "es") return es_metadata_merge_primary_group_help(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_primary_group_help(inputs)
	if (locale === "ja") return ja_metadata_merge_primary_group_help(inputs)
	if (locale === "hi") return hi_metadata_merge_primary_group_help(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_primary_group_help(inputs)
	return en_metadata_merge_primary_group_help(inputs)
});